import {
  List,
  Datagrid,
  TextField,
  Edit,
  SimpleForm,
  TextInput,
  Create,
  Show,
  SimpleShowLayout,
} from 'react-admin';

export const LanguageList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="code" />
      <TextField source="name" />
    </Datagrid>
  </List>
);

export const LanguageEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="code" />
      <TextInput source="name" />
    </SimpleForm>
  </Edit>
);

export const LanguageCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="code" required />
      <TextInput source="name" required />
    </SimpleForm>
  </Create>
);

export const LanguageShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="code" />
      <TextField source="name" />
    </SimpleShowLayout>
  </Show>
);
